/* eslint-disable react/no-danger */
import React, { HTMLProps } from 'react';

import { t } from './i18next';

interface Props<T> extends Omit<HTMLProps<T>, 'translate'> {
  l10n: string;
  translate?: boolean;
  className?: string;
  tag?: keyof JSX.IntrinsicElements;
}

export function HtmlL10n<T = HTMLSpanElement>({
  tag = 'span',
  l10n,
  translate,
  ...props
}: Props<T>) {
  return React.createElement(tag, {
    dangerouslySetInnerHTML: { __html: translate ? t(l10n) : l10n },
    ...props
  });
}
HtmlL10n.displayName = 'HtmlL10n';
HtmlL10n.defaultProps = {
  translate: false
};
